import { graphql } from 'src/gql';

export const MARK_ONBOARDING_HOUSEHOLD_COMPLETE_MUTATION = graphql(/* GraphQL */ `
  mutation MarkOnboardingHouseholdComplete($stagedHouseholdId: ID!) {
    markOnboardingHouseholdComplete(input: { stagedHouseholdId: $stagedHouseholdId }) {
      success
      errors {
        field
        message
      }
    }
  }
`);
